import styled from "@emotion/styled"

const HeroCaseItemTitle = styled.span`
  font-weight: 700;
  margin-bottom: 12px;
`

export default HeroCaseItemTitle
